export default "__VITE_ASSET__DSwu2Oo5__"